import { useSite } from "@/contexts/SiteContext";
import { RenderIcon } from "@/components/admin/IconPicker";

export default function Benefits() {
  const { sectionContent } = useSite();
  const c = sectionContent("benefits");
  if (!c) return null;
  const items = c.items || [];
  if (items.length === 0) return null;

  return (
    <section
      data-testid="benefits-section"
      className="w-full"
      style={{
        background: "var(--ct-surface)",
        borderTop: "1px solid var(--ct-border-gold)",
        borderBottom: "1px solid var(--ct-border-gold)",
      }}
    >
      <div className="max-w-[1440px] mx-auto">
        {/* Desktop: horizontal strip, 4 columns, ~104px height */}
        <div
          className="hidden lg:grid grid-cols-4"
          style={{ minHeight: "104px" }}
        >
          {items.map((it, i) => (
            <div
              key={i}
              data-testid={`benefit-${i}`}
              className="flex items-center justify-center gap-4 px-6 py-4"
              style={{
                borderRight: i < items.length - 1 ? "1px solid var(--ct-border)" : "none",
              }}
            >
              <div
                className="flex items-center justify-center shrink-0"
                style={{ width: "42px", height: "42px" }}
              >
                <RenderIcon value={it.icon} size={28} color={i % 2 === 0 ? "var(--ct-gold)" : "var(--ct-emerald)"} />
              </div>
              <div className="text-left">
                <h3 data-el="item_title" data-field={`items.${i}.title`} className="text-base font-bold leading-tight" style={{ color: "var(--ct-text)" }}>{it.title}</h3>
                <p data-el="item_body" data-field={`items.${i}.desc`} className="text-xs leading-[1.35] mt-0.5" style={{ color: "var(--ct-text-muted)" }}>{it.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile: grilă 2×2 lizibilă (4 coloane erau ilizibile sub 400px) */}
        <div className="lg:hidden grid grid-cols-2 gap-x-2 gap-y-3 px-3 py-4">
          {items.map((it, i) => (
            <div
              key={i}
              className="flex flex-col items-center justify-start gap-1 px-2 py-1 text-center"
              data-testid={`benefit-mobile-${i}`}
            >
              <div className="flex items-center justify-center" style={{ width: "34px", height: "34px" }}>
                <RenderIcon value={it.icon} size={22} color={i % 2 === 0 ? "var(--ct-gold)" : "var(--ct-emerald)"} />
              </div>
              <h3 data-el="item_title" data-field={`items.${i}.title`} className="text-[13px] font-semibold leading-[1.25]" style={{ color: "var(--ct-text)" }}>{it.title}</h3>
              <p data-el="item_body" data-field={`items.${i}.desc`} className="text-[11px] leading-[1.3]" style={{ color: "var(--ct-text-muted)" }}>{it.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
